import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=79b44497&scoped=true&"
import script from "./PaymentComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaymentComponent.vue?vue&type=style&index=0&id=79b44497&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b44497",
  null
  
)

export default component.exports